seedWebApp.controller('IndexMaterialsCtrl', ['$scope', '$routeParams', '$location', '$window',
    function ($scope, $routeParams, $location, $window) {

        $scope.defaultPages = [                    
            { pageIndex: 0, pageLabel: 'Stocks', pageDisplay: 'Materials/Stocks', pageUrl: 'SPA/materials/stocks.html' + seedWebApp.buildVersion },
            { pageIndex: 1, pageLabel: 'Materials', pageDisplay: 'Materials/Materials', pageUrl: 'SPA/materials/materials.html' + seedWebApp.buildVersion },
            { pageIndex: 2, pageLabel: 'References', pageDisplay: 'Materials/Refers', pageUrl: 'SPA/materials/refers.html' + seedWebApp.buildVersion },
            //{ pageIndex: 2, pageLabel: 'SKUs', pageDisplay: 'Materials/MaterialSkus', pageUrl: 'SPA/materials/materialSkus.html' + seedWebApp.buildVersion },
            //{ pageIndex: 3, pageLabel: 'Drawings', pageDisplay: 'Materials/Drawings', pageUrl: 'SPA/materials/drawings.html' + seedWebApp.buildVersion },
        ];

        $scope.loadingTabs = true;
        $scope.selTab = $routeParams.Tab;

        $scope.tabSelected = function (page) {
            $location.search('Tab', page.pageIndex);
            $scope.selectedIndex = page.pageIndex;
        };

        $(document).ready(function () {
            $scope.overflowSize = $scope.AdjustSize();
        });

        $window.onresize = function () {
            $scope.overflowSize = $scope.AdjustSize();
        };

        $scope.$watch('modules', function () {
            if ($scope.modules) {
                $scope.verifyPermsAndDefineTabs($scope, 'Stocks');
            }
        });
    }
]);